<!--我的订单-->
<template>
  <div class="home-main myOrder">
    <div class="main" v-loading="loading">
      <div class="main_title">
        <span class="title-cn">试用申请</span>
        <span class="title-en">/trail phones</span>
      </div>
      <!--筛选部分start-->
      <div class="myOrder-selector">
        <div class="select-item">
          <p>日期</p>
          <el-date-picker value-format="yyyy-MM-dd" v-model="create_time_s" type="date" align="right" :picker-options="pickerOptions1" size="small">
          </el-date-picker>
          <span class="demonstration">到</span>
          <el-date-picker value-format="yyyy-MM-dd" v-model="create_time_e" type="date" align="right" :picker-options="pickerOptions2" size="small">
          </el-date-picker>
        </div>
        <el-button size="small" class="warning" @click="search">搜索</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
      </div>
      <!--筛选部分end-->

      <div class="myOrder-main-line"></div>

      <!--订单列表start-->
      <div class="myOrder-main-list">
        <el-table height="100%" :data="tableData" style="width: 100%;" stripe>
          <el-table-column width="40">
          </el-table-column>
          <el-table-column label="手机号">
            <template slot-scope="scope">
              <span>{{ scope.row.phone}}</span>
            </template>
          </el-table-column>
          <el-table-column label="IP地址">
            <template slot-scope="scope">
              <span>{{ scope.row.ip}}</span>
            </template>
          </el-table-column>
          <el-table-column label="产品线">
            <template slot-scope="scope">
              <span>{{ scope.row.source_page}}</span>
            </template>
          </el-table-column>
          <el-table-column label="申请日期">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time}}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否已录入">
            <template slot-scope="scope">
              <span>{{ scope.row.in_crm?'是':'否'}}</span>
              <span v-if="!scope.row.in_crm" style="margin-left: 10px;">
                <el-button @click="enterCRM(scope)" type="text" size="mini">
                  录入
                </el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--订单列表end-->
      <div class="pagination">
        <el-pagination :disabled="!pagination.use" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.currentPage" :page-sizes="[ 20, 30, 50, 100]" :page-size="pagination.size" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
        </el-pagination>
      </div>
    </div>

    <!--产品加点弹窗start-->
    <el-dialog title="订单详细" :visible.sync="rowDetailDialog" width="600px">
      <el-table :data="rowDetail" border style="width: 100%">
        <el-table-column v-for="(item, key) in rowDetailConfig" :key="key" :prop="key" :label="item">
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--产品加点弹窗end-->
  </div>
</template>

<script>
  import { getTrail_log, updateTrail } from "@/api/opportunity";
  import { createGetUrlParams } from "@/utils/url";
  export default {
    data() {
      return {
        /*筛选条件-产品start*/
        loading: false,
        selectmyOrdersValue: '',
        authCode: '', //授权码
        pagination: {
          use: true,
          total: 0,
          size: 20,
          currentPage: 1,
        },
        selectmyOrders: [{
          selectmyOrdersValue: '选项1',
          label: 'FastBI产品'
        }, {
          selectmyOrdersValue: '选项2',
          label: 'C9开发版'
        }, {
          selectmyOrdersValue: '选项3',
          label: 'C9标准版'
        }, {
          selectmyOrdersValue: '选项4',
          label: 'C9高级版'
        }],
        /*筛选条件-产品end*/

        /*筛选条件-下单时间start*/
        create_time_s: '', //选择下单时间-开始
        create_time_e: '', //选择下单时间-结束
        pickerOptions1: {
          shortcuts: [{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 1);
              picker.$emit('pick', date);
            }
          }, {
            text: '最近7天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }, {
            text: '最近30天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            }
          }, {
            text: '最近90天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', date);
            }
          }, {
            text: '最近1年',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', date);
            }
          }]
        },
        pickerOptions2: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
        /*筛选条件-下单时间end*/

        /*表格数据start*/
        tableData: [],
        /*表格数据end*/
        rowDetailConfig: {},
        rowDetail: [], //行数据-详细
        rowDetailDialog: false
      };
    },
    mounted() {
      this.getTrailPhonesData()
    },
    methods: {
      enterCRM(scope) {
        console.log(scope);
        this.$confirm('是否录入crm', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            phone: scope.row.phone,
            source_page: scope.row.source_page,
            in_crm: true
          }
          updateTrail(scope.row.id, data).then(res => {
            this.$message({
              message: '录入crm成功',
              type: 'success'
            });
            this.getTrailPhonesData()
          }).catch(err => {
            console.log(err);
          })
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
      },
      handleCurrentChange(val) {
        this.pagination.currentPage = val
        this.getTrailPhonesData()
      },
      handleSizeChange(val) {
        if (val <= this.pagination.total) {
          this.pagination.size = val
          this.getTrailPhonesData()
        }
      },
      getTrailPhonesData() {
        this.loading = true
        let params = {
          p: this.pagination.currentPage,
          count: this.pagination.size
        }
        let result = createGetUrlParams(params)
        if (result.success) {
          getTrail_log(result.data).then(response => {
            this.loading = false
            this.pagination.total = response.count | 0
            this.tableData = response.results
          }).catch(() => {
            this.loading = false
          })
        }
      },
      search() {
        let params = {
          create_time_s: this.create_time_s,
          create_time_e: this.create_time_e,
        }
        let result = createGetUrlParams(params)

        if (result.success) {
          this.loading = true
          getTrail_log(result.data).then(response => {
            this.tableData = response.results
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
          this.restPage(true)

        }
      },
      resetSearch() {
        this.restPage(true)
        this.create_time_s = ''
        this.create_time_e = ''
        this.getTrailPhonesData()
      },
      restPage(isUsePagination) {
        this.pagination.use = isUsePagination
        this.pagination.currentPage = 1
        this.pagination.size = 20
      },
    }
  };
</script>

<style lang="scss">
  /*筛选部分start*/
  .myOrder {
    .main {
      display: flex;
      flex-direction: column;
      margin: 0px 14px;
      height: 100%;
      //background-color: #FFFFFF;
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;

      .main_title {
        margin: 15px 0;
      }

      .myOrder-main-list {
        flex-grow: 1;
      }

    }
  }

  .myOrder-selector {
    padding: 18px 0px 20px 24px !important;
    min-width: 980px !important;
    font-size: 12px !important;
    height: 32px !important;
    background: #fff;
  }

  .select-item {
    float: left !important;
    margin-right: 34px !important;
  }

  .select-item .el-date-editor {
    width: 180px !important;
  }

  .select-item .el-input__inner {
    padding-right: 0px !important;
  }

  .select-item p {
    padding-right: 10px !important;
    float: left !important;
    height: 32px !important;
    line-height: 32px !important;
    text-align: right !important;
  }

  .select-input {
    float: left !important;
    width: 180px !important;
  }

  .selcet-myOrder .el-input__inner {
    width: 150px !important;
    height: 32px !important;
    line-height: 32px !important;
  }

  .el-select-dropdown__list {
    padding: 6px 0px 22px 0px !important;
  }

  .el-select-dropdown span {
    font-size: 12px !important;
  }

  /*筛选部分end*/

  .myOrder-main-line {
    width: 100% !important;
    border-bottom: 1px solid #ededed !important;
  }

  /*订单列表start*/
  .myOrder-main-list {
    min-width: 1100px !important;
    height: 430px;
    /*margin-top: 10px!important;*/
    /*margin:35px 30px 0px 30px!important;*/
  }

  .myOrder-main-list .cell span {
    font-size: 12px !important;
  }

  /*订单列表end*/
</style>


// WEBPACK FOOTER //
// src/components/operation/trail_phones.vue